import { render } from "./FinancialTriviaGame.vue?vue&type=template&id=6abb8c82&scoped=true"
import script from "./FinancialTriviaGame.vue?vue&type=script&lang=js"
export * from "./FinancialTriviaGame.vue?vue&type=script&lang=js"

import "./FinancialTriviaGame.vue?vue&type=style&index=0&id=6abb8c82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abb8c82"]])

export default __exports__